import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet'
import ProductCard from '../../../ProductCard'
import CustomSlick from '../../../CustomSlick'
import { sendClickPromoDataToAnalytics, ORIGINS } from '../../../../common/GoogleTagManager'
import { defaultSettingsTopProducts } from './utils'
import './index.css'

// EVALUAR CAMBIAR A FUNCTIONAL COMPONENT
class ProductsInCarousel extends Component {
  showTopProducts = ({ className, isMobile, promotionProducts, customSettingsTopProducts = null, width }) => {
    if (isMobile) {
      return (
        <div className="d-flex category-products-slide m-10 pb-10 mr-10">
          {this.renderTopPromotionProducts(isMobile, promotionProducts)}
        </div>
      )
    }
    const settings = customSettingsTopProducts || defaultSettingsTopProducts
    return (
      <CustomSlick
        style={{
          padding: '10px 0',
          buttonSize: '35px',
          buttonPadding: '5px',
          previousOffset: '-28px',
          nextOffset: '-28px',
          width: width,
        }}
        className={`${className} slicks-controller`}
        {...settings}
      >
        {this.renderTopPromotionProducts(isMobile, promotionProducts)}
      </CustomSlick>
    )
  }

  generateMeta = (promotionProducts) => (
    <Helmet>
      <meta property="og:type" content="product.group" />
      {promotionProducts.map((product, index) => (
        <meta property="og:image" content={`${product?.images?.mediumImage}`} key={index} />
      ))}
    </Helmet>
  )

  renderTopPromotionProducts = (isMobile, promotionProducts) => {
    const { origin, flowType } = this.props
    const productsCarouselClass = isMobile ? 'products-carousel-home-mobile' : 'products-carousel-home'
    return promotionProducts.map((hit, index) => (
      <div
        role="presentation"
        key={`categoryImage-${index}`}
        onKeyPress={() => {
          sendClickPromoDataToAnalytics(hit.displayName, origin, index, hit.ID)
        }}
        onClick={() => {
          sendClickPromoDataToAnalytics(hit.displayName, origin, index, hit.ID)
        }}
      >
        <div className={`${productsCarouselClass} ${isMobile && 'mr-20'}`}>
          <ProductCard
            isMobile={isMobile}
            hit={hit}
            origin={origin || ORIGINS.HOME_PAGE}
            carouselMaxWidth
            flowType={flowType}
          />
        </div>
      </div>
    ))
  }

  render() {
    const { className, isMobile, promotionProducts, customSettingsTopProducts, origin, tenant, width } = this.props
    return (
      <div
        className={`products-in-corousel_wrapper products-in-corousel_wrapper--${tenant}`}
        data-testid="products-in-carousel-testid"
      >
        {this.generateMeta(promotionProducts)}
        {this.showTopProducts({ className, isMobile, promotionProducts, customSettingsTopProducts, origin, width })}
      </div>
    )
  }
}

ProductsInCarousel.propTypes = {
  className: PropTypes.string,
  categoryName: PropTypes.string,
  isMobile: PropTypes.bool,
  promotionProducts: PropTypes.array,
  customSettingsTopProducts: PropTypes.any,
  origin: PropTypes.string,
  flowType: PropTypes.string,
  tenant: PropTypes.string,
  width: PropTypes.number,
}

ProductsInCarousel.defaultProps = {
  categoryName: '',
  isMobile: true,
  promotionProducts: [],
  customSettingsTopProducts: null,
  origin: '',
  flowType: '',
  className: '',
  tenant: 'catalogo',
  width: '100%',
}

export default ProductsInCarousel
